import { Container, Input } from 'components/atoms';
import { t } from 'i18next';
import { PiBank, PiHouseLine, PiWallet } from 'react-icons/pi';
import { useGetLabel } from 'services/labels';
import { CUSTOMER_TYPE } from 'services/labels/types';
import { useGetCountries } from 'services/enums';
import { AddressForm } from 'components/molecules';
import ViewHint from 'components/molecules/hint/ViewHint';

const LabelTaxOffice = () => {
  const { data: label } = useGetLabel();
  const countries = useGetCountries();

  const getCountryLabel = (code?: string) => {
    if (!code) return '';

    const country = countries.data?.find((c) => c.codeAlfa2 === code);

    return country ? t(`countries.${country.codeAlfa2}`) : code;
  };

  return (
    <>
      <div />
      <ViewHint hintId="label-tax-office" />
      <Input.Text
        name={`taxOffice.name`}
        label={t('input.label.name')}
        // wrapperClassName='max-w-80'
        fullWidth
        value={label?.taxOfficeName}
        readOnly
      />
      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name={`taxOffice.countryAlfa2`}
          label={t('input.label.country')}
          value={getCountryLabel(label?.taxOfficeAddressCountry)}
          borderless
          fullWidth
          readOnly
        />
        <Input.Text
          name={`taxOffice.zipCode`}
          label={t('input.label.zipCode')}
          borderless
          fullWidth
          value={label?.taxOfficeAddressZipCode}
          readOnly
        />
      </Input.ComplexWrapper>
      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name={`taxOffice.city`}
          label={t('input.label.city')}
          borderless
          fullWidth
          value={label?.taxOfficeAddressCity}
          readOnly
        />
        <Input.Text
          name={`taxOffice.street`}
          label={t('input.label.street')}
          borderless
          fullWidth
          value={label?.taxOfficeAddressStreet}
          readOnly
        />
      </Input.ComplexWrapper>
      <Input.ComplexWrapper sizes={[50, 50]}>
        <Input.Text
          name={`taxOffice.houseNumber`}
          label={t('input.label.houseNumber')}
          borderless
          fullWidth
          value={label?.taxOfficeAddressHouseNumber}
          readOnly
        />
        <Input.Text
          name={`taxOffice.flatNumber`}
          label={t('input.label.flatNumber')}
          borderless
          fullWidth
          value={label?.taxOfficeAddressFlatNumber}
          readOnly
        />
      </Input.ComplexWrapper>
    </>
  );
};

export default LabelTaxOffice;
